import { useAuth } from 'context/AuthContext';
import { hidesPurchasePrices } from 'utils/helpers/access/hasUserAccess';
import { formatPrice } from "utils/helpers/functions/formatPrice";
import { withLocalCurrency, withPrimaryCurrency } from "utils/helpers/currency/currencyHelpers";
import { useSettings } from "context/SettingsContext";
import PriceAndPriceSale from "components/others/PriceAndPriceSale";

type ProductOperPriceProps = {
    operation: any;
    /** У об'єкті — ціна продажу; у складі (за замовч.) — курс грн */
    showSalePrice?: boolean;
};

const ProductOperPrice = ({operation, showSalePrice = false}: ProductOperPriceProps) => {
    const { auth } = useAuth();
    const { localSettings } = useSettings();
    const rate = Number(localSettings?.RATE?.current ?? 1) || 1;
    const isUahMode = rate === 1;
    const hidePurchase = hidesPurchasePrices(auth?.user);

    const price = formatPrice(operation?.operPrice);
    const priceRate = formatPrice(operation?.operPriceRate);

    if (showSalePrice) {
        return (
            <PriceAndPriceSale
                price={Number(operation?.operPrice) || 0}
                priceSale={Number(operation?.operPriceSale) || 0}
            />
        );
    }

    if (hidePurchase) return null;

    return (<>
        <h6 className="mb-1">{withPrimaryCurrency(price, rate)}</h6>
        {!isUahMode && (
            <p className="text-muted f-12 mb-0 my-1">{withLocalCurrency(priceRate)}</p>
        )}
    </>)
}
 
export default ProductOperPrice;
